# Just overrides the default name of the HotspotGroup model
BaseHotspotGroupModel = require 'models/hotspot-group-base'
baseModel = _.clone BaseHotspotGroupModel
baseModel.defaults = _.extend {}, baseModel.defaults, {
    name: 'Untitled Tooltips'
    sequential: true
}
module.exports = Backbone.Model.extend baseModel

